/**
 * @prettier
 * @author Alexander Nagelberg
 */
import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { useParams, Link } from 'react-router-dom'

import { formatLin } from 'app/utils/fieldUtils'
import { prefetchRefunds } from '../actions/fundingfeeActions'

const RefundNavigationBar = ({ fundingFee, refunds, prefetchRefunds }) => {
  const { page: pageInfo, filter, refundsInfo } = fundingFee
  const { id } = useParams()
  const refund = fundingFee[id]

  const currentRefund = useMemo(() => refunds?.find(refund => refund.id === parseInt(id) ?? null), [refunds, id])

  useEffect(() => {
    // If we're doing paging, we're going to pre-fetch nearby next/prevpage
    if (pageInfo?.page != null && currentRefund != null) {
      const { page, limit } = pageInfo
      const { pageIndex } = currentRefund
      const lastPage = refundsInfo.totalRefunds / limit
      const firstPage = 0

      if (pageIndex === 0 && page !== firstPage && refunds[0] === currentRefund) {
        // on first of page, pre-fetch previous page of refunds
        prefetchRefunds({ ...filter, limit, page: page - 1 })
      } else if (pageIndex === limit - 1 && page !== lastPage && refunds[refunds.length - 1] === currentRefund) {
        // on last of page, pre-fetch next page of refunds
        prefetchRefunds({ ...filter, limit, page: page + 1 })
      }
    }
  }, [refunds, currentRefund, pageInfo, refundsInfo, filter, prefetchRefunds])

  if (!refunds) {
    // If there's no list in the store, it's pointless to display this component
    return null
  }

  const refundIndex = refunds.findIndex(refund => refund.id === parseInt(id))
  const nextRefund = refundIndex < refunds.length - 1 ? refunds[refundIndex + 1].id : false
  const prevRefund = refundIndex > 0 ? refunds[refundIndex - 1].id : false

  return (
    <div className='lgy-funding-fee-refund-nav'>
      <Link to={`./${prevRefund}`}>
        <button
          className='left-button'
          aria-label='Previous Search Result'
          disabled={fundingFee.fetching || !prevRefund}
        >
          {'<'}
        </button>
      </Link>
      <h3>
        {' '}
        {refund?.lin ? (
          <a href={`/lgyhub/WebLGY/LINInquiry.do?LIN=${refund.lin}`} target={refund.lin}>{`LIN #${formatLin(
            refund.lin
          )}`}</a>
        ) : (
          `Refund ID #${id}`
        )}
      </h3>
      <Link to={`./${nextRefund}`}>
        <button className='right-button' aria-label='Next Search Result' disabled={fundingFee.fetching || !nextRefund}>
          {'>'}
        </button>
      </Link>
    </div>
  )
}

const mapStateToProps = state => ({
  fundingFee: state.fundingFee,
  refunds: state.fundingFee?.refunds?.sort((r1, r2) => r1.id - r2.id)
})

export default connect(mapStateToProps, { prefetchRefunds })(RefundNavigationBar)
